import { Service } from "@angular/core";

@Service()
export class RecorderService {
  data: any[] = [];

  addSection(section: string) {
    this.data.push({ section });
  }

  addComment(comment: string) {
    this.data.push({ comment });
  }

  add(label: string, value: number, detail: string) {
    this.data.push({ label, value, detail });
  }
}
